module.exports = "<div><sliders-t1 ng-if=$ctrl.dbData.isCarousel cb-items=$ctrl.dbData.items cb-name=$ctrl.dbName></sliders-t1><div ng-if=!$ctrl.dbData.isCarousel><a href=\"{{$ctrl.dbData.items[0].url ? $ctrl.dbData.items[0].url : '#'}}\" title={{$ctrl.dbData.items[0].title}}><img ng-src={{$ctrl.dbData.items[0].imageUrl}} class=img-reponsive></a></div></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./www/components/home/sliders/sliders.view.html
 ** module id = 719
 ** module chunks = 7
 **/